(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yf-stock-note"] && !Shopify.designMode) return;
  try {
    document.addEventListener('booster:variant:select', function(event) {
  const detail = event.detail;
  if (!detail || !detail.product || !detail.selectedVariant) return;
  document.querySelectorAll('[data-yf-stock-product]').forEach(function(note) {
    if (note.dataset.yfStockProduct !== String(detail.product.id)) return;
    note.querySelectorAll('[data-yf-stock-variant]').forEach(function(row) {
      row.hidden = row.dataset.yfStockVariant !== String(detail.selectedVariant.id);
    });
  });
});
document.addEventListener('booster:variant:deselect', function(event) {
  if (!event.detail || !event.detail.product) return;
  document.querySelectorAll('[data-yf-stock-product]').forEach(function(note) {
    if (note.dataset.yfStockProduct === String(event.detail.product.id)) {
      note.querySelectorAll('[data-yf-stock-variant]').forEach(function(row) { row.hidden = true; });
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
